import { FormGroup } from '@angular/forms';
import { resolveNameTitleCodeForSelect } from '@app/helpers/name-title-select.helper';
import { Person } from '@app/models/account.model';
import { PersonalDataFormGroup } from '@app/models/form.models';
import { LocalizedValue } from '@app/models/shared.models';

export function patchPersonalDataFormGroup(
  form: FormGroup<PersonalDataFormGroup>,
  personalData: Person,
  nameTitles: readonly LocalizedValue[],
): void {
  form.patchValue({
    title:
      resolveNameTitleCodeForSelect(personalData.titleCode, nameTitles) ?? '',
    familyName: personalData.lastName ?? '',
    middleName: personalData.midName ?? '',
    givenName: personalData.firstName ?? '',
    citizenship: personalData.citizenship ?? '',
    birthLastName: personalData.maidenLastName ?? '',
    birthMiddleName: personalData.maidenMidName ?? '',
    birthFirstName: personalData.maidenFirstName ?? '',
    birthPlace: personalData.birthPlace ?? '',
    dateOfBirth: personalData.birthDate ?? '',
    motherLastName: personalData.motherLastName ?? '',
    motherMiddleName: personalData.motherMidName ?? '',
    motherFirstName: personalData.motherFirstName ?? '',
    certificateType: personalData.idCardType ?? null,
    numberOfCertificate: personalData.idCardNumber ?? '',
    expiryDate: personalData.idCardNumberExpiry ?? '',
    country: personalData.address?.countryCode ?? '',
    postalCode: personalData.address?.zipCode ?? '',
    city: personalData.address?.city ?? '',
    publicSpace: personalData.address?.publicSpace ?? '',
    publicSpaceType: personalData.address?.publicSpaceType ?? '',
    houseNumber: personalData.address?.houseNumber ?? '',
    doorOrFloor: personalData.address?.doorOrFloor ?? '',
    optionalTaxNumber: personalData.taxIdentifier ?? '',
    optionalBankNumber: personalData.bankAccountNumber ?? '',
  });
}
